exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".paymentWorldpay{padding-top:0!important}.cardBloc{margin-bottom:0!important}payment-worldpay .dimmer{position:fixed!important}@media (max-width:360px){.ticket fieldset table.listCard p span:first-child{font-size:.8em!important}}@media (max-width:320px){.ticket fieldset table.listCard p span:first-child{font-size:.7em!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/manage-purchase/my-purchase/buy-product/payment-worldpay/payment-worldpay.styl
// module id = 935
// module chunks = 0